const DEFAULT_SCROLL_DELAY_MS = 180;
const LAYOUT_SETTLE_DELAY_MS = 420;

function getStickyHeaderOffset() {
  if (typeof document === 'undefined') {
    return 0;
  }

  const header = document.querySelector('.site-header');
  if (!header) {
    return 0;
  }

  return Math.ceil(header.getBoundingClientRect().height);
}

export function scrollToAnchor(anchorOrElement, { behavior = 'smooth' } = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const target = typeof anchorOrElement === 'string'
    ? document.getElementById(anchorOrElement.replace(/^#/, ''))
    : anchorOrElement;

  if (!target) {
    return false;
  }

  const top = target.getBoundingClientRect().top + window.pageYOffset - getStickyHeaderOffset();

  window.scrollTo({
    top: Math.max(0, Math.round(top)),
    behavior,
  });

  return true;
}

export function scrollToAnchorAfterLayout(anchorOrElement, options) {
  if (typeof window === 'undefined') {
    return false;
  }

  let didScroll = false;
  const scroll = () => {
    didScroll = scrollToAnchor(anchorOrElement, options) || didScroll;
  };
  const raf = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));

  raf(() => {
    raf(scroll);
  });

  window.setTimeout(scroll, DEFAULT_SCROLL_DELAY_MS);
  window.setTimeout(scroll, LAYOUT_SETTLE_DELAY_MS);

  return didScroll;
}
